import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useNodeDetails = (id, nodeId) => {
    return useQuery(QUERY_KEY.NODE_DETAILS, () => ApiService.nodeDetails(id, nodeId), {retry: false})
}

export default useNodeDetails